<div class="items-center flex flex-col justify-start custom-height-copilot p-2">
    <!-- question answer  -->
    <div class="custom-height-main-content-with-scope mb-2"
    [ngClass]="{
      'custom-height-for-canvas': type === 'CANVAS',
    }"
    >
      @if(questionsAndAnswersLoading) {
        <div class="mt-12">
          <ui-skeleton-chat-copilot />
        </div>
        } @else {
        <div *ngIf="isLoadingData" class="flex justify-center items-center h-full">
          <app-loader [loadingText]="'Setting up conversation...'"></app-loader>
        </div>
        <div *ngIf="!isLoadingData ">
          <div *ngIf="questions.length > 0 || answers.length > 0; else noMessages">
            <div *ngFor="let question of questions; let questionIndex = index" class="mt-2">
              <!-- User bubble -->
              <div class="text-right flex items-center justify-end">
                <p class="py-2 px-4 rounded-lg max-w-[90%] bg-[#EFF8FF] text-black text-basepx] break-words select-text">
                  {{ question?.parameters?.INPUT_TEXT }}
                </p>
                <img [src]="userPhoto()" alt="User Photo" class="ml-2 h-8 w-8 rounded-full" />
              </div>
    
              <div *ngIf="answers[questionIndex]?.isLoading" class="text-left flex items-center justify-start mt-2">
                <div class="flex items-center justify-center">
                  <ui-icon name="data-copilot" class="stroke-[#77ABF9] stroke-[1.5px] mr-2" size="size-6"></ui-icon>
                  <p class="shimmer text-[#1B1F26B8] text-basepx]">
                    Generating a Response...
                  </p>
                </div>
              </div>
    
              <div *ngIf="
                !answers[questionIndex]?.isLoading && answers[questionIndex]?.text
              " class="text-left flex-col justify-start mt-2 max-w-[90%] relative">
                <div class="flex justify-start">
                  <ui-icon name="data-copilot" class="stroke-[#77ABF9] stroke-[1.5px] mr-2 py-2" size="size-6"></ui-icon>
                  <div *ngIf="answers[questionIndex]?.warning; else normalAnswer"
                    class="py-2 px-4 rounded-lg max-w-[90%] bg-[#f9f2f4] text-[#c7254e] text-basepx] select-text">
                    {{ answers[questionIndex].text }}
                  </div>
                  <ng-template #normalAnswer>
                    <div class="py-2 px-4 rounded-lg max-w-[90%] bg-[#F5F5F5] text-black text-[13px] markdown-container select-text"
                      *ngIf="
                      answers[questionIndex]?.type == 'simple'
                    ">
                      <div>
                        <markdown [data]="answers[questionIndex].text" class="prose"></markdown>
                      </div>
                    </div>
                  </ng-template>

                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-template #noMessages>
          <div class="flex items-center justify-center h-full mt-56">
            <div class="text-center flex flex-col items-center">
              <ui-icon
              name="data-copilot"
              class="stroke-[#87a4cf] stroke-2"
              size="size-12"
            ></ui-icon>
            <p class="text-[#475467] text-center max-w-[202px] text-sm mt-2">
              Ask copilot any question on this report...
            </p>
            </div>
          </div>
        </ng-template>
        }
    </div>

    <div class="flex items-center rounded-[8px] px-4 py-1 w-[95%] bg-[#1018280D] mx-auto cursor-pointer">
      <input type="text" placeholder="Ask me anything about your data..." [(ngModel)]="messageText"
        class="focus:outline-none bg-transparent p-2 w-full disabled:cursor-not-allowed" (keydown.enter)="sendMessage()"
        [disabled]="(!selectedScope && type !== 'CANVAS') || isAnswerLoading || questionsAndAnswersLoading" />
      <button class="p-2 rounded-lg bg-[#77ABF9] disabled:cursor-not-allowed disabled:bg-[#D0D5DD]"
        (click)="sendMessage()" [disabled]="(!selectedScope && type !== 'CANVAS') || isAnswerLoading || questionsAndAnswersLoading">
        <ui-icon name="send-message" class="stroke-[2px]" [ngClass]="
          (selectedScope || type === 'CANVAS') && !isAnswerLoading && !questionsAndAnswersLoading
            ? 'stroke-white'
            : 'stroke-black stroke-opacity-30'
        " />
      </button>
    </div>
    <div class="flex items-center justify-center py-2 mx-auto text-center">
      <p class="text-[#5D5D5D] text-xs">
        Data Copilot can make mistakes. 
        <br/>
        Check the
        <a href="#" class="text-blue-600 underline" (click)="openTermsModal($event)">Terms and Conditions</a>
        &
        <a href="#" class="text-blue-600 underline" (click)="openPrivacyModal($event)">Privacy Policy</a>
      </p>
    </div>
  </div>


